import { render, staticRenderFns } from "./Mailings.vue?vue&type=template&id=4042780a"
import script from "./Mailings.vue?vue&type=script&lang=js"
export * from "./Mailings.vue?vue&type=script&lang=js"
import style0 from "./Mailings.vue?vue&type=style&index=0&id=4042780a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports